import { DISCARDED_RESPONSE_STRINGS, REMOVED_RESPONSE_STRINGS } from 'garaje/utils/enums';

export default function isRemovedString(
  value?: string | null,
): value is typeof REMOVED_RESPONSE_STRINGS.PLACEHOLDER | typeof DISCARDED_RESPONSE_STRINGS.PLACEHOLDER {
  return value === REMOVED_RESPONSE_STRINGS.PLACEHOLDER || value === DISCARDED_RESPONSE_STRINGS.PLACEHOLDER;
}
